import React from "react";
import PropTypes from "prop-types";
import "./ActiveFilterChips.css";

const ActiveFilterChips = ({
  chips,
  onRemoveChip,
  onClearAll,
}) => {
  if (!chips?.length) return null;

  return (
    <div className="active-filter-chips" role="region" aria-label="Active filters and sorting">
      <div className="active-filter-chips-scroll">
        <div className="active-filter-chips-row">
          {chips.map((chip) => (
            <span key={chip.id} className="active-filter-chip">
              <span className="active-filter-chip-label">{chip.label}</span>
              <button
                type="button"
                className="active-filter-chip-remove"
                aria-label={`Remove ${chip.label}`}
                onClick={() => onRemoveChip(chip)}
              >
                ×
              </button>
            </span>
          ))}
          <button type="button" className="active-filter-clear-all" onClick={onClearAll}>
            Clear All
          </button>
        </div>
      </div>
    </div>
  );
};

ActiveFilterChips.propTypes = {
  chips: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.oneOf(["filter", "sort"]).isRequired,
      label: PropTypes.string.isRequired,
      key: PropTypes.string,
    })
  ),
  onRemoveChip: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
};

export default ActiveFilterChips;
